import { Form, Select } from "antd";
import { getIsVisibleLookups } from "utilities/generalUtility";
import { LabeledField } from "../labeledField/labeledField";

const { Option } = Select;

export const JobDepartmentField = ({
  lookupTables = {},
  clientId,
  editData,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const jobDepartmentLookups = lookupTables.jobDepartment || [];

  const renderField = () => (
    <Select
      showSearch
      allowClear
      placeholder="Select Job Departments"
      optionFilterProp="children"
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      disabled={disabled}
      style={style}
    >
      {getIsVisibleLookups(
        jobDepartmentLookups.filter(
          (lookup) => parseInt(lookup.clientId) === parseInt(clientId),
        ),
        editData?.jobDepartment?.id,
      ).map((item) => (
        <Option key={item.id} value={item.id} disabled={item.isVisible !== 1}>
          {item.name}
        </Option>
      ))}
    </Select>
  );

  if (isFormItem) {
    return (
      <Form.Item label="Job Department" name="jobDepartmentsId">
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Job Department" extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
